module.exports = __webpack_public_path__ + "static/img/1-1Z523164641438.ebbbc12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z523164641438.jpg
// module id = bPda
// module chunks = 0